import React from "react";
import * as api from "../api/index";

const AdminUserDetails = ({ usersData, setUsersData }) => {
  function handleApproval(e, ele) {
    api.SubmitApproval(ele).then((data) => {
      alert(data.data.message);
      window.location.href="/account/adminPanel";  
      //setUsersData(usersData.map((user) => (user._id === ele._id ? user.isApproved:true)));
    });
  }

  return (
    <>
      <h1>
        <strong>User Details</strong>
      </h1>
      <div className="user-table-div-parent">
        <center className="user-table-div">
          <table>
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Username</th>
                <th>Full Name</th>
                <th>Email ID</th>
                <th>Role</th>
                <th>Approval Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {usersData.map((ele, idx) => (
                <tr key={idx}>
                  <td>
                    <p
                      className={`bg-${ele.profileColor}-500 text-white rounded-full w-7`}
                    >
                      {idx + 1}
                    </p>
                  </td>
                  <td>{ele.userName}</td>
                  <td>{ele.firstName + " " + ele.lastName}</td>
                  <td>{ele.email}</td>
                  <td>{ele.role}</td>
                  <td>{ele.isApproved ? "Approved" : "Approval Pending"}</td>
                  <td>
                    {ele.isApproved ? (
                      <button className="style-pointer-none bg-blue-500 hover:bg-gray-600 px-6 py-2 rounded text-white">
                        Approved
                      </button>
                    ) : (
                      <button
                        className="bg-green-500 hover:bg-gray-600 px-6 py-2 rounded text-white"
                        onClick={(e) => handleApproval(e, ele)}
                      >
                        Approve
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </>
  );
};

export default AdminUserDetails;
